import React, { useState, useEffect, useRef } from "react";
import EmployeeForm from "./EmployeeForm";
import Pagination from "../../../utils/pagination/Pagination";
// import DetailForm from '../detailpage/DetailForm.js';
import { Trash2, SquarePen, Eye, Plus } from "lucide-react";
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer, Checkbox, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Button, ModalCloseButton, Spinner } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import ProgressBar from "../../../utils/progressBar/ProgressBar.js";
import { getEmployees } from "../../../redux/reduxApi/employeeReduxApi.js";
import { useDispatch, useSelector } from "react-redux";
import { pageData } from "../../../utils/paginationConfig.js";
import { toast } from "react-toastify";
import { deleteEmployee } from "../../../redux/api/employeeApi/EmployeeApi.js";
import { deleteEmployeeAction } from "../../../redux/reduxSlice/EmployeeSlice.js";
import { countEmployees } from "../../../redux/api/employeeApi/EmployeeApi.js";
import DealEmployeeForm from "../../crm/deal/DealEmployeeForm.js";
import EllipsisMenu from "../../../utils/EllipsisDropdown/EllipsisMenu.js";
import { formatDate } from "../../../utils/commonFunction/CommonFunction.js";
import EmployeesMobileList from "./mobileList/EmployeesMobileList.js";
function Employees() {
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [deleteEmployeeROWID, setDeleteEmployeeROWID] = useState("");
  const [employeeROWID, setEmployeeROWID] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const getEmployeeData = useSelector((state) => state?.employee?.employee);
  const [employeeData, setEmployeeData] = useState([]);
  const [data, setData] = useState([]);
  const [dataToEdit, setDataToEdit] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const getRoleData = useSelector((state) => state.utils.roleList);
  const [role, setRole] = useState([]);
  const getDepartmentData = useSelector((state) => state.utils.departmentList);
  const [department, setDepartment] = useState([]);
  const [lastScrollY, setLastScrollY] = useState(0);
  const scrollRef = useRef(null);
  const tableRef = useRef(null);
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);
  const [ismobile, setIsmobile] = useState(false);

  const [showMobileNav, setShowMobileNav] = useState(true);

  const navigate = useNavigate();

  //to show add & delete button according to permissions
  const permissions = localStorage.getItem("permissions");
  const filterData = JSON.parse(permissions);

  // Track DealEmployeeForm-specific drawer state
  const [isDealFormOpen, setIsDealFormOpen] = useState(false);

  useEffect(() => {
    setRole(getRoleData);
  }, [getRoleData]);

  useEffect(() => {
    setDepartment(getDepartmentData);
    console.log("getDepartmentData", department);
  }, [getDepartmentData]);

  // console data to be displayed
  useEffect(() => {
    setEmployeeData(getEmployeeData);
  }, [getEmployeeData]);
  console.log("getEmployeeData", getEmployeeData);

  // Get employess -->
  useEffect(() => {
    const page = 1;
    setLoading(true);
    dispatch(getEmployees({ page: currentPage, limit: 30, size: 30 }))
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {}, [300]);
      });
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (employeeData && employeeData.length > 0) {
      setData(employeeData);
    }
  }, [employeeData]);

  const roleName = (roleName) => {
    const roleData = role.filter((item) => item.roles?.ROWID === roleName);
    return roleData[0]?.roles.roleName || "NA";
  };

  const departmentName = (departmentName) => {
    console.log("hyy", department);
    const departmentData = department.filter((item) => item?.ROWID === departmentName);
    console.log("departmentData", departmentData);
    return departmentData[0]?.departmentName || "NA";
  };

  useEffect(() => {
    if (currentPage % pageData.apiHit === 0) {
      const page = currentPage / pageData.apiHit + 1;
      dispatch(getEmployees(page));
    }
  }, [totalPages]);

  // Handle Delete Function
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteEmployeeROWID] : selectedRows;
    Promise.all(idsToDelete.map((id) => deleteEmployee(id)))
      .then(() => {
        setData((prevData) => prevData.filter((item) => !idsToDelete.includes(item.employees.ROWID)));
        dispatch(deleteEmployeeAction(idsToDelete));
        fetchTotalCount();
        toast.success("Row Deleted successfully");
        fetchTotalCount();
      })
      .catch((error) => {
        console.log(error);
        toast.error("Row not deleted");
      })
      .finally(() => {
        setShowProgressBar(false);
        setLoading(false);
        closeTrash();
        setSelectedRows([]);
        setEmployeeROWID("");
      });
  };

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };
  const [isDrawerOpen1, setIsDrawerOpen1] = useState(false);

  const openDrawer1 = () => {
    setIsDrawerOpen1(true);
  };
  const closeDrawer1 = () => {
    setIsDrawerOpen1(false);
  };
  const handleScroll = () => {
    if (scrollRef.current) {
      const currentScrollY = scrollRef.current.scrollTop; // Get scroll position from content
      if (currentScrollY > lastScrollY) {
        setShowMobileNav(false); // Scrolling down, hide MobileNav
      } else {
        setShowMobileNav(true); // Scrolling up, show MobileNav
      }

      setLastScrollY(currentScrollY); // Update the last scroll position
    }
  };

  useEffect(() => {
    const contentElement = scrollRef.current;
    if (contentElement) {
      contentElement.addEventListener("scroll", handleScroll); // Attach the scroll event to the content div
    }
    return () => {
      if (contentElement) {
        contentElement.removeEventListener("scroll", handleScroll); // Cleanup event listener
      }
    };
  }, [lastScrollY]);
  // for Trash modal
  const openTrash = () => {
    setIsOpen(true);
  };
  const closeTrash = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (getEmployeeData) {
      setEmployeeData(getEmployeeData);
      setTotalPages(Math.ceil(getEmployeeData.length / 30));
    }
  }, [getEmployeeData]);

  // Single Select
  const handleRowSelect = (ROWID) => {
    const isSelected = selectedRows.includes(ROWID);
    let newSelectedRows = [];

    if (!isSelected) {
      newSelectedRows = [...selectedRows, ROWID];
    } else {
      newSelectedRows = selectedRows.filter((rowEmployeeId) => rowEmployeeId !== ROWID);
    }
    setSelectedRows(newSelectedRows);
    setEmployeeROWID(newSelectedRows.join(","));
  };
  // All Select
  const handleSelectAllRows = () => {
    const allSelected = selectedRows.length === data.length;
    let newSelectedRows = [];
    if (!allSelected) {
      newSelectedRows = data.map((item) => item.employees?.ROWID);
    }
    setSelectedRows(newSelectedRows);
  };
  // handle update
  const handleUpdate = (id) => {
    setEmployeeROWID(id);
    setIsUpdateMode(!isUpdateMode);
  };

  // total companies count
  const fetchTotalCount = async () => {
    try {
      const response = await countEmployees();
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total Attendance count:", error);
    }
  };

  useEffect(() => {
    fetchTotalCount();
  }, []);

  // when a new company is added
  const handleNewEmployeeAdded = () => {
    fetchTotalCount();
  };

  // function to check screen size and show hide contente
  const handleResize = () => {
    if (window.innerWidth < 600) {
      desktopRef.current.classList.add("d-none");
      mobileRef.current.classList.remove("d-none");
      setIsmobile(true);
    } else {
      desktopRef.current.classList.remove("d-none");
      mobileRef.current.classList.add("d-none");
      setIsmobile(false);
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}
      {/* Trash modal confirmation */}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{/* Optional body content */}</ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div ref={desktopRef} style={{ maxHeight: ismobile ? "98vh" : "80vh" }}>
        {/* New employee button */}
        <div className="d-flex justify-content-end">
          {filterData?.find((mod) => mod.moduleName === "Employee" && mod.add === true) && (
            <button className="new-button mx-2" onClick={openDrawer}>
              <Plus size="18px" />
              <span className="ms-1">New</span>
            </button>
          )}
        </div>

        {/* Employee data table */}
        <div className="custom-scroll" style={{ minHeight: "75vh", overflow: "scroll" }}>
          <TableContainer
            className='className="card card-detail mt-1  scrollable-container'
            // style={{ minHeight: "51vh", position: "relative" }}
            style={{
              maxHeight: "70vh",
              position: "relative",
              overflowY: "scroll",
              scrollbarColor: "#A0AEC0 #EDF2F7",
              scrollbarWidth: "10px",
            }}
            ref={tableRef}
          >
            <Table variant="simple" size="sm">
              <Thead>
                <Tr className="tr-border">
                  <Th className="py-1 th-color">
                    <Checkbox isChecked={selectedRows?.length === data?.length} onChange={handleSelectAllRows} />
                  </Th>
                  <Th className="py-1 th-color">Actions</Th>
                  <Th className="py-1 th-color">Employee Name</Th>
                  <Th className="py-1 th-color">Permission </Th>
                  <Th className="py-1 th-color">Email</Th>
                  <Th className="py-1 th-color">Department </Th>
                  <Th className="py-1 th-color">Date Of Birth</Th>
                  <Th className="py-1 th-color">Phone Number</Th>
                  <Th className="py-1 th-color">Start Date</Th>
                  <Th className="py-1 th-color">Rate/Hour</Th>
                  <Th className="py-1 th-color">Employee Status</Th>
                  <Th className="py-1 th-color">Tax Code</Th>
                  <Th className="py-1 th-color">Bank</Th>
                  <Th className="py-1 th-color">Branch</Th>
                  <Th className="py-1 th-color">Created Time</Th>
                  <Th className="py-1 th-color">Modified Time</Th>
                  <Th className="py-1 th-color">Created By</Th>
                </Tr>
              </Thead>
              <Tbody>
                {employeeData?.map((item, index) => (
                  <Tr key={index} className="tr-border" style={{ cursor: "pointer", position: "relative" }}>
                    <Td>
                      <Checkbox isChecked={selectedRows.includes(item?.employees?.ROWID)} onChange={() => handleRowSelect(item?.employees?.ROWID)} />
                    </Td>
                    <Td style={{ width: "110px", textAlign: "center" }} onClick={(e) => e.stopPropagation()}>
                      <EllipsisMenu
                        item={item}
                        onView={() => navigate("/employee-detail-view", { state: { ROWID: item?.employees?.ROWID } })}
                        onEdit={() => {
                          openDrawer(item.employees);
                          setDataToEdit(item.employees);
                          setIsUpdateMode(true);
                        }}
                        onDelete={() => {
                          openTrash();
                          setDeleteEmployeeROWID(item?.employees?.ROWID);
                        }}
                        permissions={{
                          canEdit: filterData?.find((mod) => mod.moduleName === "Employee" && mod.modifyAll === true),
                          canDelete: filterData?.find((mod) => mod.moduleName === "Employee" && mod.delete === true),
                          canView: true, // Usually always true, but you can make this dynamic too
                        }}
                      />
                    </Td>
                    <Td className="font-colors">{item?.employees?.employeeName}</Td>
                    <Td
                      className="font-colors text-center d-inline-block text-truncate"
                      style={{ minWidth: "170px", maxWidth: "170px", color: " #f27d7d", background: "#fceaf0", border: "1px solid rgb(249, 184, 184)", borderRadius: "12px", marginBlock: "3px" }}
                    >
                      {roleName(item?.employees?.permissions)}
                    </Td>
                    <Td className="font-colors">{item?.employees?.email}</Td>
                    <Td
                      className="font-colors text-center d-inline-block text-truncate"
                      style={{ minWidth: "170px", maxWidth: "170px", backgroundColor: " #cae1d8", color: " #1f4956", border: "1px solid rgb(146, 189, 202)", borderRadius: "12px", marginBlock: "3px" }}
                    >
                      {departmentName(item?.employees?.department)}
                    </Td>

                    <Td className="font-colors">{item?.employees?.dateOfBirth}</Td>
                    <Td className="font-colors">{item?.employees?.phoneNumber}</Td>
                    <Td className="font-colors">{formatDate(item?.employees?.startDate)}</Td>
                    <Td className="font-colors">{item?.employees?.rateHour}</Td>
                    <Td className="font-colors">{item?.employees?.employeeStatus}</Td>
                    <Td className="font-colors">{item?.employees?.taxCode}</Td>
                    <Td className="font-colors">{item?.employees?.bank}</Td>
                    <Td className="font-colors">{item?.employees?.branch}</Td>
                    <Td className="font-colors">{formatDate(item?.employees?.CREATEDTIME?.slice(0, 16))}</Td>
                    <Td className="font-colors">{formatDate(item?.employees?.MODIFIEDTIME?.slice(0, 16))}</Td>
                    <Td className="font-colors">{item?.employees?.createdBy}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>

        <div className="footer d-flex fixed-bottom start-20">
          <div className="total" style={{ marginLeft: "20%", marginTop: "15px" }}>
            <p class="fw-semibold">Total Count:{totalCount} </p>
          </div>
          {/* Pagination */}
          <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
            <Pagination totalPages={Math.ceil(totalCount / 30)} onPageChange={setCurrentPage} />
          </div>
          {/* End Pagination */}
          {/* EmployeeForm Drawer */}
          <EmployeeForm
            closeDrawer={() => setIsDrawerOpen(false)}
            isDrawerOpen={isDrawerOpen}
            isUpdateMode={isUpdateMode}
            employeeROWID={employeeROWID}
            setIsUpdateMode={setIsUpdateMode}
            dataToEdit={dataToEdit}
            // onNewEmployeeAdded={() => fetchTotalCount()}
          />
          {/* DealEmployeeForm Drawer */}
          {isDealFormOpen && (
            <DealEmployeeForm
              employeeROWID={employeeROWID}
              setIsUpdateMode={setIsUpdateMode}
              dataToEdit={dataToEdit}
              // onNewEmployeeAdded={() => fetchTotalCount()}
            />
          )}
        </div>
      </div>

      <div ref={mobileRef} style={{ maxHeight: "100vh" }} className="d-none">
        <EmployeesMobileList employeeData={employeeData} openDrawer={openDrawer} openTrash={openTrash} setDataToEdit={setDataToEdit} setIsUpdateMode={setIsUpdateMode} totalCount={totalCount} />
      </div>
    </>
  );
}

export default Employees;
